import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorkerManager from './serviceWorkerManager';
import MyTheme from './Theme';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Router from './Router';
import './index.css';

ReactDOM.render(
  <MuiThemeProvider theme={MyTheme}>
    <Router />
  </MuiThemeProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorkerManager.register();
